import styled from "styled-components";
import { theme } from "../theme";

export const StyledDecisionLink = styled.div`
	margin-top: 1.6rem;
	padding-top: 1.6rem;
	border-top: 1px solid ${theme.color.blue1};

	display: flex;
	align-items: center;
	column-gap: 0.5rem;

	& img:last-child {
		margin-left: 0.5rem;
		width: 0.8rem;

		cursor: pointer;
	}

	& > a {
		display: flex;
		align-items: center;
		column-gap: 0.5rem;

		& img:first-child {
			width: 1.4rem;
		}

		&.active {
			color: ${theme.color.green};
		}

		&.inactive {
			color: ${theme.color.blue3};

			& a,
			& a:active,
			& a:hover,
			& a:visited {
				color: ${theme.color.blue3};
			}
		}
	}
`;
